class TSSingleProduct extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("ts-cart");
    this.checkoutRedirect = this.hasAttribute("data-checkout");

    this.querySelector(".ts-single-product__cart-button").addEventListener("click", this.addToCart.bind(this));
  }

  addToCart() {
    const currentVariant = this.querySelector("form input:checked").value;
    const cartData = {items: [{id: parseInt(currentVariant),quantity: 1}]};

    if (this.cart) {
      cartData.sections = ["ts-cart", "ts-cart-bubble"];
      cartData.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    }).then((response) => {
      return response.json()
    }).then((response) => {
      if (response.status) {
        this.querySelector(".ts-single-product__cart-error").textContent = response.description;
        throw response.description;
      } else {
        this.querySelector(".ts-single-product__cart-error").textContent = '';
      }

      if (this.cart) {
        this.cart.renderContent(response.sections);
        if (this.checkoutRedirect) {
          setTimeout(() => {
            document.querySelector("ts-cart [orderly-procceded]").click();
          }, 1000)
        } else {
          this.cart.toggleMenu(false);
        }
      } else {
        window.location = window.routes.cart_url;
      }
    }).catch((error) => console.error(error));
  };
}

customElements.define('ts-single-product', TSSingleProduct);